/**
 * @author jakubbujakowski
 * @since 2021-9-7
 */

import * as React from "react";
import { Redirect } from "react-router-dom";

import { IS_BROWSER } from "@config/consts";

interface Props {
  possibleRoutes: string[];
}

const MakeRedirect = (props: Props) => {
  if (IS_BROWSER) {
    const pathArray = window.location.pathname.split("/");
    const pathname = pathArray[pathArray.length - 1];

    if (props.possibleRoutes.indexOf(pathname) > -1) {
      return <Redirect to={pathname} />;
    }

    return null;
  }

  return null;
};

MakeRedirect.displayName = "MakeRedirect";

export { MakeRedirect };
